import { ResourceCentre } from "../interfaces/ResourceCentreInterface";
import useCurrentResourceCentre from "./useCurrentResourceCentre";

export interface ResolvedOkhatiAiSettings {
  enabled: boolean;
  transcriptionApiKey: string;
  prompt: string;
}

export const DEFAULT_OKHATI_AI_SETTINGS: ResolvedOkhatiAiSettings = {
  enabled: false,
  transcriptionApiKey: "",
  prompt: ""
};

export const SPEECHMATICS_DEFAULT_API_URL = "https://mp.speechmatics.com/v1";

export function resolveOkhatiAiSettings(
  resourceCentre?: ResourceCentre | null
): ResolvedOkhatiAiSettings {
  const okhatiAi = resourceCentre?.settings?.okhatiAiSettings;

  return {
    enabled: okhatiAi?.enabled ?? false,
    transcriptionApiKey: (okhatiAi?.transcriptionApiKey ?? "").trim(),
    prompt: (okhatiAi?.prompt ?? "").trim()
  };
}

/** Keep transcriptionApiKey in Redux when the API omits it from PUT responses. */
export function mergeResourceCentreOkhatiAiSettings(
  saved: ResourceCentre,
  response: ResourceCentre
): ResourceCentre {
  const savedKey = (saved.settings?.okhatiAiSettings?.transcriptionApiKey ?? "").trim();
  const responseKey = (response.settings?.okhatiAiSettings?.transcriptionApiKey ?? "").trim();

  if (!savedKey || responseKey) {
    return response;
  }

  return {
    ...response,
    settings: {
      ...response.settings,
      okhatiAiSettings: {
        ...response.settings.okhatiAiSettings,
        enabled:
          saved.settings.okhatiAiSettings?.enabled ?? response.settings.okhatiAiSettings?.enabled,
        transcriptionApiKey: savedKey,
        prompt:
          saved.settings.okhatiAiSettings?.prompt ?? response.settings.okhatiAiSettings?.prompt
      }
    }
  };
}

export function isOkhatiAiReady(settings: ResolvedOkhatiAiSettings): boolean {
  return settings.enabled && Boolean(settings.transcriptionApiKey);
}

export function isDeepSeekReady(settings: ResolvedOkhatiAiSettings): boolean {
  return settings.enabled;
}

export default function useOkhatiAiSettings(): ResolvedOkhatiAiSettings & {
  isReady: boolean;
} {
  const resourceCentre = useCurrentResourceCentre();
  const settings = resolveOkhatiAiSettings(resourceCentre);

  return {
    ...settings,
    isReady: isOkhatiAiReady(settings)
  };
}
